import { Layout } from 'antd';
import { Navigation } from '@/components/navigation';

import { useContextReady } from '@/hooks/useContextReady';

import { initGoogleAnalytics } from '@/utils/ga';

const { Header, Content, Footer, Sider } = Layout;

// @ts-ignore
export const DefaultLayout = ({ children }) => {
  useContextReady(() => {
    initGoogleAnalytics()
  })

  return (
    <Layout>
      <Sider
        width={300}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
        }}
      >
        <Navigation />
      </Sider>
    <Layout className="site-layout" style={{ marginLeft: 300 }}>
      {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
      <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
        <div className="site-layout-background" style={{ padding: 24, textAlign: 'center' }}>
          { children }
        </div>
      </Content>
      {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}
    </Layout>
  </Layout>
  )
}